import React, { useState } from 'react';
import { TextField, Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import emailjs from "emailjs-com";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    from_name: '',
    reply_to: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    console.log(process.env.REACT_APP_EMAILJS_SERVICE_ID);
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.EMAILJS_PUBLIC_KEY
      )
      .then((result) => {
        alert("Message sent successfully!");
        setFormData({ from_name: "", reply_to: "", message: "" });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Name"
          fullWidth
          margin="dense"
          variant="outlined"
          color="secondary"
          onChange={handleChange}
          required
          id="form-name"
          name="from_name"
          value={formData.from_name}
        />
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="dense"
          variant="outlined"
          color="secondary"
          placeholder="Your email"
          onChange={handleChange}
          required
          id="form-email"
          name="reply_to"
          value={formData.reply_to}
        />
        <TextField
          label="Message"
          fullWidth
          margin="dense"
          multiline
          rows={5}
          variant="outlined"
          color="secondary"
          onChange={handleChange}
          required
          id="form-message"
          name="message"
          value={formData.message}
        />
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<SendIcon />}
          size="large"
          type="submit"
        >
          send
        </Button>
      </form>
    </ThemeProvider>
  );
};

const theme = createTheme({
  palette: {
    mode: 'dark',
    secondary: { main: '#fcfcfb' },
    text: { secondary: '#fcfcfb' },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        slotProps: {
          input: { style: { fontSize: '1.8rem' } },
          inputLabel: { style: { fontSize: '1.8rem' } },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "1.4rem",
          marginTop: "8px",
          transition: "background-color 0.3s ease, color 0.3s ease",
          "&:hover": {
            backgroundColor: "rgba(255, 165, 0, 0.2)",
          },
        },
      },
    },
  }
});

export default ContactForm;
